import React from 'react';

/**
 * Renders the provided date as date string using .toLocaleDateString()
 */
export function LocaleDate(props: any) {
  const isDate = props.date && Object.prototype.toString.call(props.date) === '[object Date]' && !isNaN(props.date);
  if (isDate) {
    return <>{(props.date as Date).toLocaleDateString()}</>
  }
  return null;
}
